<template>
<div class="chapter">
<div class="inner_page">
<h1 class="section"><strong class="bold">OUT OF ITALY</strong></h1>
<p class="basic-paragraph"> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// outofitaly_00000.vue?3ad31b6b